
import { z } from "zod";

// Form validation schema
export const formSchema = z.object({
  firstName: z.string().min(2, "Le prénom doit contenir au moins 2 caractères"),
  lastName: z.string().min(2, "Le nom doit contenir au moins 2 caractères"),
  email: z.string().email("Email invalide"),
  phone: z.string().min(10, "Le numéro de téléphone doit contenir au moins 10 chiffres"),
  age: z.string().min(1, "Veuillez indiquer votre âge"),
  situation: z.string().min(1, "Veuillez sélectionner votre situation"),
  productCategory: z.string().min(1, "Veuillez sélectionner une catégorie de produit"),
  revenus: z.string().min(1, "Veuillez indiquer vos revenus annuels"),
  charges: z.string().min(1, "Veuillez indiquer vos charges annuelles"),
  immobilier: z.string().optional(), // Made optional since it's in a collapsible section
  financier: z.string().optional(), // Made optional since it's in a collapsible section
  objectifs: z.string().min(1, "Veuillez indiquer vos objectifs"),
  consentement: z.boolean().refine(val => val === true, {
    message: "Vous devez accepter la politique de confidentialité",
  }),
});

export type FormValues = z.infer<typeof formSchema>;
